<script setup lang="ts">
import { inject, onMounted, onUnmounted } from 'vue'

const context = inject<{
  register: () => void
  unregister: () => void
} | null>('appContext', null)

onMounted(() => context?.register())
onUnmounted(() => context?.unregister())
</script>

<template>
  <Teleport defer to="#app-context-target">
    <slot />
  </Teleport>
</template>
